import { InteractiveField as BaseInteractiveField } from '@tabeo/scarf'
import React from 'react'
import Field from './Field'

const InteractiveField = React.forwardRef((props, ref) => {
  return <Field ref={ref} {...props} ScarfField={BaseInteractiveField} />
})

export default InteractiveField
